module.exports = __webpack_public_path__ + "pc/img/body_basic 13.2e2129cc.jpg";